<template>
    <section>
        <div class="row">
            <span class="text_11" :lines="1">推荐课程</span>
            <div class="colorDiv_3" />
        </div>
        <div class="row1">
            <el-card shadow="hover" :body-style="{ padding: '0px'}">
                <div class="col1" @click="$router.push('course/detail')">
                    <img
                            class="img"
                            src="../images/img_32389_0_398.png"
                    />
                    <img
                            class="image_2"
                            src="../images/img_32389_0_397.png"
                    />
                    <img
                            class="entryPic"
                            src="../images/img_32389_0_396.png"
                    />
                    <div class="view_12">
                        <div class="block_28">
                            <img
                                    class="icon_17"
                                    src="../images/img_32389_0_414.png"
                            />
                            <div class="group_4">
                                <img
                                        class="img_2"
                                        src="../images/img_32389_0_398.png"
                                />
                                <img
                                        class="verticalLine"
                                        src="../images/img_32389_0_408.png"
                                />
                                <img
                                        class="verticalLine_2"
                                        src="../images/img_32389_0_409.png"
                                />
                            </div>
                            <img
                                    class="icon_18"
                                    src="../images/img_32389_0_399.png"
                            />
                            <img
                                    class="verticalLine_3"
                                    src="../images/img_32389_0_406.png"
                            />
                            <img
                                    class="verticalLine_4"
                                    src="../images/img_32389_0_407.png"
                            />
                            <img
                                    class="verticalLine_5"
                                    src="../images/img_32389_0_404.png"
                            />
                            <img
                                    class="verticalLine_6"
                                    src="../images/img_32389_0_405.png"
                            />
                            <img
                                    class="verticalLine_7"
                                    src="../images/img_32389_0_402.png"
                            />
                            <img
                                    class="verticalLine_8"
                                    src="../images/img_32389_0_403.png"
                            />
                            <img
                                    class="dot_2"
                                    src="../images/img_32389_0_400.png"
                            />
                            <div class="block_26">
                                <img
                                        class="pic"
                                        src="../images/img_32389_0_397.png"
                                />
                                <img
                                        class="verticalLine_9"
                                        src="../images/img_32389_0_401.png"
                                />
                            </div>
                            <div class="group_5">
                                <img
                                        class="verticalLine_10"
                                        src="../images/img_32389_0_410.png"
                                />
                                <img
                                        class="verticalLine_11"
                                        src="../images/img_32389_0_411.png"
                                />
                            </div>
                            <div class="block_27">
                                <img
                                        class="verticalLine_12"
                                        src="../images/img_32389_0_412.png"
                                />
                                <img
                                        class="img_3"
                                        src="../images/img_32389_0_413.png"
                                />
                            </div>
                        </div>
                        <span class="info_16" :lines="1">深度学习与子人语深度</span>
                    </div>
                    <div class="block_29">
                        <span class="info_17" :lines="1">深度学习与子人处深</span>
                        <span class="word_12" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_2">
                        <div class="block_30">
                            <div class="group_6">
                                <img
                                        class="icon_19"
                                        src="../images/img_32389_0_415.png"
                                />
                                <img
                                        class="picture_2"
                                        src="../images/img_32389_0_416.png"
                                />
                                <img
                                        class="icon_20"
                                        src="../images/img_32389_0_417.png"
                                />
                            </div>
                            <span class="num_4" :lines="1">2389</span>
                        </div>
                        <span class="money_2" :lines="1">¥1200.00</span>
                    </div>
                </div>
            </el-card>

            <el-card shadow="hover" :body-style="{ padding: '0px'}">
                <div class="col2" @click="$router.push('course/detail')">
                    <img
                            class="pic_2"
                            src="../images/img_32389_0_376.png"
                    />
                    <img
                            class="img_4"
                            src="../images/img_32389_0_375.png"
                    />
                    <img
                            class="entryPic_2"
                            src="../images/img_32389_0_374.png"
                    />
                    <div class="block_34">
                        <div class="block_33">
                            <img
                                    class="icon_21"
                                    src="../images/img_32389_0_392.png"
                            />
                            <div class="block_31">
                                <img
                                        class="img_5"
                                        src="../images/img_32389_0_376.png"
                                />
                                <img
                                        class="verticalLine_13"
                                        src="../images/img_32389_0_386.png"
                                />
                                <img
                                        class="verticalLine_14"
                                        src="../images/img_32389_0_387.png"
                                />
                            </div>
                            <img
                                    class="icon_22"
                                    src="../images/img_32389_0_377.png"
                            />
                            <img
                                    class="verticalLine_15"
                                    src="../images/img_32389_0_384.png"
                            />
                            <img
                                    class="verticalLine_16"
                                    src="../images/img_32389_0_385.png"
                            />
                            <img
                                    class="verticalLine_17"
                                    src="../images/img_32389_0_382.png"
                            />
                            <img
                                    class="verticalLine_18"
                                    src="../images/img_32389_0_383.png"
                            />
                            <img
                                    class="verticalLine_19"
                                    src="../images/img_32389_0_380.png"
                            />
                            <img
                                    class="verticalLine_20"
                                    src="../images/img_32389_0_381.png"
                            />
                            <img
                                    class="dot_3"
                                    src="../images/img_32389_0_378.png"
                            />
                            <div class="group_7">
                                <img
                                        class="pic_3"
                                        src="../images/img_32389_0_375.png"
                                />
                                <img
                                        class="verticalLine_21"
                                        src="../images/img_32389_0_379.png"
                                />
                            </div>
                            <div class="block_32">
                                <img
                                        class="verticalLine_22"
                                        src="../images/img_32389_0_388.png"
                                />
                                <img
                                        class="verticalLine_23"
                                        src="../images/img_32389_0_389.png"
                                />
                            </div>
                            <div class="group_8">
                                <img
                                        class="verticalLine_24"
                                        src="../images/img_32389_0_390.png"
                                />
                                <img
                                        class="img_6"
                                        src="../images/img_32389_0_391.png"
                                />
                            </div>
                        </div>
                        <span class="info_18" :lines="1">深度学习与子人语深度</span>
                    </div>
                    <div class="view_13">
                        <span class="info_19" :lines="1">深度学习与子人处深</span>
                        <span class="text_12" :lines="1">…</span>
                    </div>
                    <div class="priceWrap_2">
                        <div class="block_36">
                            <div class="block_35">
                                <img
                                        class="icon_23"
                                        src="../images/img_32389_0_393.png"
                                />
                                <img
                                        class="picture_3"
                                        src="../images/img_32389_0_394.png"
                                />
                                <img
                                        class="icon_24"
                                        src="../images/img_32389_0_395.png"
                                />
                            </div>
                            <span class="num_5" :lines="1">2389</span>
                        </div>
                        <span class="price_2" :lines="1">¥1200.00</span>
                    </div>
                </div>
            </el-card>

            <el-card shadow="hover" :body-style="{ padding: '0px'}">
                <div class="col3">
                    <img
                            class="picture_4"
                            src="../images/img_32389_0_354.png"
                    />
                    <img
                            class="pic_4"
                            src="../images/img_32389_0_353.png"
                    />
                    <img
                            class="entryPic_3"
                            src="../images/img_32389_0_352.png"
                    />
                    <div class="view_14">
                        <div class="block_39">
                            <img
                                    class="icon_25"
                                    src="../images/img_32389_0_370.png"
                            />
                            <div class="group_9">
                                <img
                                        class="img_7"
                                        src="../images/img_32389_0_354.png"
                                />
                                <img
                                        class="verticalLine_25"
                                        src="../images/img_32389_0_364.png"
                                />
                                <img
                                        class="verticalLine_26"
                                        src="../images/img_32389_0_365.png"
                                />
                            </div>
                            <img
                                    class="icon_26"
                                    src="../images/img_32389_0_355.png"
                            />
                            <img
                                    class="verticalLine_27"
                                    src="../images/img_32389_0_362.png"
                            />
                            <img
                                    class="verticalLine_28"
                                    src="../images/img_32389_0_363.png"
                            />
                            <img
                                    class="verticalLine_29"
                                    src="../images/img_32389_0_360.png"
                            />
                            <img
                                    class="verticalLine_30"
                                    src="../images/img_32389_0_361.png"
                            />
                            <img
                                    class="verticalLine_31"
                                    src="../images/img_32389_0_358.png"
                            />
                            <img
                                    class="verticalLine_32"
                                    src="../images/img_32389_0_359.png"
                            />
                            <img
                                    class="dot_4"
                                    src="../images/img_32389_0_356.png"
                            />
                            <div class="block_37">
                                <img
                                        class="pic_5"
                                        src="../images/img_32389_0_353.png"
                                />
                                <img
                                        class="verticalLine_33"
                                        src="../images/img_32389_0_357.png"
                                />
                            </div>
                            <div class="group_10">
                                <img
                                        class="verticalLine_34"
                                        src="../images/img_32389_0_366.png"
                                />
                                <img
                                        class="verticalLine_35"
                                        src="../images/img_32389_0_367.png"
                                />
                            </div>
                            <div class="block_38">
                                <img
                                        class="verticalLine_36"
                                        src="../images/img_32389_0_368.png"
                                />
                                <img
                                        class="img_8"
                                        src="../images/img_32389_0_369.png"
                                />
                            </div>
                        </div>
                        <span class="info_20" :lines="1">深度学习与子人语深度</span>
                    </div>
                    <div class="block_40">
                        <span class="info_21" :lines="1">深度学习与子人处深</span>
                        <span class="txt_14" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_3">
                        <div class="block_41">
                            <div class="group_11">
                                <img
                                        class="icon_27"
                                        src="../images/img_32389_0_371.png"
                                />
                                <img
                                        class="picture_5"
                                        src="../images/img_32389_0_372.png"
                                />
                                <img
                                        class="icon_28"
                                        src="../images/img_32389_0_373.png"
                                />
                            </div>
                            <span class="num_6" :lines="1">2389</span>
                        </div>
                        <span class="money_3" :lines="1">¥1200.00</span>
                    </div>
                </div>
            </el-card>

            <el-card shadow="hover" :body-style="{ padding: '0px'}">
                <div class="col4">
                    <img
                            class="image_3"
                            src="../images/img_32389_0_332.png"
                    />
                    <img
                            class="picture_6"
                            src="../images/img_32389_0_331.png"
                    />
                    <img
                            class="entryPic_4"
                            src="../images/img_32389_0_330.png"
                    />
                    <div class="block_45">
                        <div class="block_44">
                            <img
                                    class="icon_29"
                                    src="../images/img_32389_0_348.png"
                            />
                            <div class="block_42">
                                <img
                                        class="img_9"
                                        src="../images/img_32389_0_332.png"
                                />
                                <img
                                        class="verticalLine_37"
                                        src="../images/img_32389_0_342.png"
                                />
                                <img
                                        class="verticalLine_38"
                                        src="../images/img_32389_0_343.png"
                                />
                            </div>
                            <img
                                    class="icon_30"
                                    src="../images/img_32389_0_333.png"
                            />
                            <img
                                    class="verticalLine_39"
                                    src="../images/img_32389_0_340.png"
                            />
                            <img
                                    class="verticalLine_40"
                                    src="../images/img_32389_0_341.png"
                            />
                            <img
                                    class="verticalLine_41"
                                    src="../images/img_32389_0_338.png"
                            />
                            <img
                                    class="verticalLine_42"
                                    src="../images/img_32389_0_339.png"
                            />
                            <img
                                    class="verticalLine_43"
                                    src="../images/img_32389_0_336.png"
                            />
                            <img
                                    class="verticalLine_44"
                                    src="../images/img_32389_0_337.png"
                            />
                            <img
                                    class="dot_5"
                                    src="../images/img_32389_0_334.png"
                            />
                            <div class="group_12">
                                <img
                                        class="pic_6"
                                        src="../images/img_32389_0_331.png"
                                />
                                <img
                                        class="verticalLine_45"
                                        src="../images/img_32389_0_335.png"
                                />
                            </div>
                            <div class="block_43">
                                <img
                                        class="verticalLine_46"
                                        src="../images/img_32389_0_344.png"
                                />
                                <img
                                        class="verticalLine_47"
                                        src="../images/img_32389_0_345.png"
                                />
                            </div>
                            <div class="group_13">
                                <img
                                        class="verticalLine_48"
                                        src="../images/img_32389_0_346.png"
                                />
                                <img
                                        class="img_10"
                                        src="../images/img_32389_0_347.png"
                                />
                            </div>
                        </div>
                        <span class="info_22" :lines="1">深度学习与子人语深度</span>
                    </div>
                    <div class="view_15">
                        <span class="info_23" :lines="1">深度学习与子人处深</span>
                        <span class="word_13" :lines="1">…</span>
                    </div>
                    <div class="priceWrap_3">
                        <div class="block_47">
                            <div class="block_46">
                                <img
                                        class="icon_31"
                                        src="../images/img_32389_0_349.png"
                                />
                                <img
                                        class="picture_7"
                                        src="../images/img_32389_0_350.png"
                                />
                                <img
                                        class="icon_32"
                                        src="../images/img_32389_0_351.png"
                                />
                            </div>
                            <span class="num_7" :lines="1">2389</span>
                        </div>
                        <span class="price_3" :lines="1">¥1200.00</span>
                    </div>
                </div>
            </el-card>

            <el-card shadow="hover" :body-style="{ padding: '0px'}">
                <div class="col5">
                    <img
                            class="img_11"
                            src="../images/img_32389_0_310.png"
                    />
                    <img
                            class="image_4"
                            src="../images/img_32389_0_309.png"
                    />
                    <img
                            class="entryPic_5"
                            src="../images/img_32389_0_308.png"
                    />
                    <div class="view_16">
                        <div class="block_50">
                            <img
                                    class="icon_33"
                                    src="../images/img_32389_0_326.png"
                            />
                            <div class="group_14">
                                <img
                                        class="img_12"
                                        src="../images/img_32389_0_310.png"
                                />
                                <img
                                        class="verticalLine_49"
                                        src="../images/img_32389_0_320.png"
                                />
                                <img
                                        class="verticalLine_50"
                                        src="../images/img_32389_0_321.png"
                                />
                            </div>
                            <img
                                    class="icon_34"
                                    src="../images/img_32389_0_311.png"
                            />
                            <img
                                    class="verticalLine_51"
                                    src="../images/img_32389_0_318.png"
                            />
                            <img
                                    class="verticalLine_52"
                                    src="../images/img_32389_0_319.png"
                            />
                            <img
                                    class="verticalLine_53"
                                    src="../images/img_32389_0_316.png"
                            />
                            <img
                                    class="verticalLine_54"
                                    src="../images/img_32389_0_317.png"
                            />
                            <img
                                    class="verticalLine_55"
                                    src="../images/img_32389_0_314.png"
                            />
                            <img
                                    class="verticalLine_56"
                                    src="../images/img_32389_0_315.png"
                            />
                            <img
                                    class="dot_6"
                                    src="../images/img_32389_0_312.png"
                            />
                            <div class="block_48">
                                <img
                                        class="pic_7"
                                        src="../images/img_32389_0_309.png"
                                />
                                <img
                                        class="verticalLine_57"
                                        src="../images/img_32389_0_313.png"
                                />
                            </div>
                            <div class="group_15">
                                <img
                                        class="verticalLine_58"
                                        src="../images/img_32389_0_322.png"
                                />
                                <img
                                        class="verticalLine_59"
                                        src="../images/img_32389_0_323.png"
                                />
                            </div>
                            <div class="block_49">
                                <img
                                        class="verticalLine_60"
                                        src="../images/img_32389_0_324.png"
                                />
                                <img
                                        class="img_13"
                                        src="../images/img_32389_0_325.png"
                                />
                            </div>
                        </div>
                        <span class="info_24" :lines="1">深度学习与子人语深度</span>
                    </div>
                    <div class="block_51">
                        <span class="info_25" :lines="1">深度学习与子人处深</span>
                        <span class="text_13" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_4">
                        <div class="block_52">
                            <div class="group_16">
                                <img
                                        class="icon_35"
                                        src="../images/img_32389_0_327.png"
                                />
                                <img
                                        class="picture_8"
                                        src="../images/img_32389_0_328.png"
                                />
                                <img
                                        class="icon_36"
                                        src="../images/img_32389_0_329.png"
                                />
                            </div>
                            <span class="num_8" :lines="1">2389</span>
                        </div>
                        <span class="money_4" :lines="1">¥1200.00</span>
                    </div>
                </div>
            </el-card>

        </div>
    </section>
</template>

<script>
    export default {
        name: "recommendCourse"
    }
</script>

<style src="../index.css" scoped />
